import { render, staticRenderFns } from "./CustomProgress.vue?vue&type=template&id=484db80b&scoped=true"
import script from "./CustomProgress.vue?vue&type=script&lang=js"
export * from "./CustomProgress.vue?vue&type=script&lang=js"
import style0 from "./CustomProgress.vue?vue&type=style&index=0&id=484db80b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484db80b",
  null
  
)

export default component.exports